"use strict";
/**
 * @author by Gor.Hakobyan on 13-May-19.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ReportMetaFiltersRootOperatorChildren = /** @class */ (function () {
    function ReportMetaFiltersRootOperatorChildren(type, filterType, excluded, isHiddenForUser, onCategory, values) {
        this.type = type || 'filter';
        this.filterType = filterType || 'in';
        this.excluded = excluded || false;
        this.isHiddenForUser = isHiddenForUser || false;
        this.onCategory = onCategory || null;
        this.values = values || null;
    }
    return ReportMetaFiltersRootOperatorChildren;
}());
exports.ReportMetaFiltersRootOperatorChildren = ReportMetaFiltersRootOperatorChildren;
//# sourceMappingURL=report-meta-filters-root-operator-children.model.js.map